module.exports = __webpack_public_path__ + "static/media/h-03.a2e411cc.png";